import React from 'react';
import { EventBusEvent } from '../../common/enums/EventBus';
import { useCloseDrawer } from '../../common/hooks/drawer';
import Drawer from '../../common/components/Drawer';
import SwipeListener from '../../common/components/SwipeListener';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import Container from './Container';
import Content from './Content';
import Header from './Header';
var CommonDisclaimer = function () {
    var closeDrawer = useCloseDrawer(EventBusEvent.ToggleDisclaimer);
    return (React.createElement(DisclaimerSubscription, null, function (_a) {
        var value = _a.value;
        var closeAction = value.closeAction, open = value.open, title = value.title, content = value.content, p = value.p, html = value.html;
        var onClose = closeAction || closeDrawer;
        return (React.createElement(SwipeListener, { onSwipeRight: onClose },
            React.createElement(Drawer, { isOpen: open, onBackdropClick: onClose },
                React.createElement(Container, null,
                    open && React.createElement(Header, { onClick: onClose, title: title }),
                    React.createElement(Content, { p: p, html: html, content: content })))));
    }));
};
export default CommonDisclaimer;
